













































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';
import { DxScrollView } from 'devextreme-vue';
import notificationService from '@/services/notificationService';
import { DxForm, DxItem, DxSimpleItem, DxGroupItem, DxLabel, DxRequiredRule } from 'devextreme-vue/form';
import Datagrid from '@/components/default/Datagrid.vue';

import dxCustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';

import customersRepository from '@/services/customers/customersRepository';
import projectsRepository from '@/services/projectsRepository';
import tasksRepository from '../tasksRepository';
import TaskTemplatesRepository from '@/modules/tasks/templates/TaskTemplatesRepository';

import settings from '@/settings.json';
import employeesRepository from '@/modules/employees/employeesRepository';
import { selectableEmployees } from '@/modules/employees/employeeSelection';

@Component({
  components: {
    DxPopup,
    DxToolbarItem,
    DxScrollView,
    DxForm,
    DxItem,
    DxSimpleItem,
    DxGroupItem,
    DxLabel,
    DxRequiredRule,
    Datagrid,
  },
})
export default class TaskPopup extends Vue {
  @Prop({ required: false })
  public value?: ITask;

  @Prop({ required: false })
  public projectId?: string;

  @Prop({ required: false })
  public parentId?: string;

  @Prop({ required: false })
  public report?: any | null;

  reports: any[] = [];

  public dto: ITaskCreateCommand = {
    title: '',
    category: '',
    parentId: '',
    description: '',
    team: '',
    dueDate: '',
    userId: '',
    projectId: '',
    templateId: '',
    customer: null,
    type: 0,
    status: 0,
  };

  templates: ITaskTemplateDto[] = [];
  showPopup: boolean = false;
  saving: boolean = false;
  employees = this.$store.getters['employees/items'] as any[];

  public show() {
    if (this.projectId) {
      this.dto.projectId = this.projectId;
    }

    if (this.parentId) {
      this.dto.parentId = this.parentId;
    }
    this.showPopup = true;
    this.reports = [];

    setTimeout(() => {
      if (this.report) {
        this.dto.reportId = this.report.id;

        if (this.report.employeeId) {
          this.report.employee = this.employees.find((e) => e.id === this.report.employeeId);
        }

        this.reports.push(this.report);
      }
    }, 500);
  }

  public hide() {
    this.showPopup = false;
  }

  public async save() {
    try {
      this.saving = true;
      const form: any = this.$refs.form;
      const validationResult = form.instance.validate();

      if (validationResult.isValid) {
        if (this.value) {
          // update
          const data = Object.assign({ id: this.value.id }, this.dto) as ITaskUpdateCommand;
          const result = await tasksRepository.update(data);
          this.$emit('input', result.data);
        } else {
          // create
          const result = await tasksRepository.create(this.dto);
          this.$router.push({ path: `/tasks/${result.data.id}` });
        }
        notificationService.saved();
        this.hide();
      } else {
        notificationService.invalidForm();
      }
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.$emit('saved');
      this.saving = false;
    }
  }

  async loadTemplates() {
    try {
      this.templates = (await TaskTemplatesRepository.getAll()).data;
    } catch {
      notificationService.showErrorMessage('Mislukt om de handleidingen te laden!');
    }
  }

  mounted() {
    if (this.value) {
      Object.assign(this.dto, this.value);
    }

    if (this.projectId) {
      this.dto.projectId = this.projectId;
    }

    if (this.parentId) {
      this.dto.parentId = this.parentId;
    }
  }

  created() {
    this.loadTemplates();
  }

  get title() {
    return this.value && this.value.id ? 'Taak wijzigen' : 'Taak aanmaken';
  }

  get customersOptions() {
    const self = this;
    return {
      dataSource: new DataSource({
        store: new dxCustomStore({
          load: async (loadOptions) => {
            const result = self.dto.projectId
              ? await projectsRepository.getProjectContacts(self.dto.projectId).then((res) => res.data)
              : await customersRepository.get(loadOptions).then((res) => res.data);

            return {
              data: result,
            };
          },
          byKey: (val: any) => {
            return val;
          },
        }),
        paginate: true,
      }),
      displayExpr: 'displayName',
      searchEnabled: true,
    };
  }

  get templatesOptions() {
    return {
      items: this.templates,
      displayExpr: 'name',
      valueExpr: 'id',
      searchEnabled: true,
      showClearButton: true,
    };
  }

  get teamOptions() {
    return {
      items: employeesRepository.getTeams(),
      displayExpr: 'text',
      valueExpr: 'value',
      searchEnabled: true,
      showClearButton: true,
    };
  }

  get projectsOptions() {
    const self = this;
    return {
      dataSource: new DataSource({
        store: new dxCustomStore({
          key: 'id',
          load: async (loadOptions: any) => {
            if (Array.isArray(loadOptions.filter) && loadOptions.filter.length > 1 && loadOptions.filter[0] === 'id') {
              return {
                data: [],
                totalCount: 0,
              };
            }
            if (loadOptions.searchExpr && loadOptions.searchValue && loadOptions.searchOperation) {
              loadOptions.filter = [loadOptions.searchExpr, loadOptions.searchOperation, loadOptions.searchValue];
            }

            const result = await projectsRepository.lookup(loadOptions);
            return {
              data: result.data.data,
              totalCount: result.data.totalCount,
            };
          },
          byKey: async (val: any) => {
            return projectsRepository.getSingle(val).then((result: any) => {
              return result.data;
            });
          },
        }),
        paginate: true,
      }),
      valueExpr: 'id',
      displayExpr: 'name',
      searchExpr: 'name',
      searchEnabled: true,
      showClearButton: true,
    };
  }

  get typesOptions() {
    return {
      items: [
        { value: 0, name: this.$t('objects.tasks.types.0') },
        { value: 1, name: this.$t('objects.tasks.types.1') },
        { value: 2, name: this.$t('objects.tasks.types.2') },
        { value: 3, name: this.$t('objects.tasks.types.3') },
        { value: 4, name: this.$t('objects.tasks.types.4') },
      ],
      valueExpr: 'value',
      displayExpr: 'name',
    };
  }

  get statusOptions() {
    return {
      items: [
        { value: 0, name: this.$t('objects.tasks.status.0') },
        { value: 1, name: this.$t('objects.tasks.status.1') },
        { value: 2, name: this.$t('objects.tasks.status.2') },
        { value: 3, name: this.$t('objects.tasks.status.3') },
        { value: 4, name: this.$t('objects.tasks.status.4') },
        { value: 5, name: this.$t('objects.tasks.status.5') },
      ],
      valueExpr: 'value',
      displayExpr: 'name',
    };
  }

  get userOptions() {
    // OS-214: this popup is used to both create and edit a task - keep an already-assigned
    // (now possibly disabled) employee visible on this field so editing an existing task never
    // silently drops its assignee.
    const objects = this.$store.getters['employees/items'];
    return {
      items: selectableEmployees(objects, { currentValue: this.dto.userId }),
      valueExpr: 'id',
      displayExpr: 'displayName',
      searchEnabled: true,
      showClearButton: true,
      showCancelButton: true,
    };
  }

  get categoryOptions() {
    return {
      items: this.$store.getters['catalogs/list']('TaskCategories').values,
      // valueExpr: 'id',
      // displayExpr: 'displayName',
      searchEnabled: false,
      showClearButton: true,
      showCancelButton: true,
    };
  }

  get reportColumns() {
    const self = this;
    return [
      {
        dataField: 'employee.displayName',
        caption: 'Medewerker',
      },
      {
        dataField: 'template',
        caption: 'Type',
      },
      {
        dataField: 'title',
        caption: 'Titel',
      },
      {
        dataField: 'date',
        caption: 'Datum',
        dataType: 'date',
        format: 'dd/MM/yyyy',
      },
      {
        dataField: 'type',
        caption: 'Soort',
        lookup: {
          dataSource: [
            {
              value: 0,
              text: 'Verslag',
            },
            {
              value: 1,
              text: 'Bezoek',
            },
          ],
          valueExpr: 'value',
          displayExpr: 'text',
        },
      },
      {
        type: 'buttons',
        buttons: [
          {
            hint: 'Open in webpagina',
            icon: 'fas fa-globe',
            visible(e: any) {
              return !e.row.isEditing && !e.row.data.isCompleted;
            },
            onClick: (e: any) => {
              window.open(e.row.data.webUrl, '_blank');
            },
          },
          {
            hint: 'Open in app',
            icon: 'fas fa-clipboard',
            visible(e: any) {
              return !e.row.isEditing && !e.row.data.isCompleted;
            },
            onClick: (e: any) => {
              window.open(e.row.data.clientUrl, '_blank');
            },
          },
        ],
      },
    ];
  }

  @Watch('dto', { deep: true })
  onDtoChanged() {
    if (this.dto.templateId && this.dto.templateId !== '') {
      const template = this.templates.find((o) => o.id === this.dto.templateId);
      if (template) {
        if (!this.dto.title || this.dto.title === '') {
          this.dto.title = template.title;
        }
        if (!this.dto.description || this.dto.description === '') {
          this.dto.description = template.description;
        }
        if (!this.dto.team || this.dto.team === '') {
          this.dto.team = template.team;
        }
        if (!this.dto.category || this.dto.category === '') {
          this.dto.category = template.category;
        }
        if (!this.dto.userId || this.dto.userId === '') {
          this.dto.userId = template.assignedUserId;
        }
      }
    }
  }
}
